import { logger } from '@/shared/helpers/logger';

const DEFAULT_API_URL = 'http://localhost:8080';

function readApiUrl(): string {
  const apiUrl = import.meta.env.VITE_API_URL;
  if (apiUrl) return apiUrl;
  logger.warn(`VITE_API_URL is not set, using default: ${DEFAULT_API_URL}`, { log_source: 'env' });

  return DEFAULT_API_URL;
}

export const API_URL = readApiUrl();
